module.exports = __webpack_public_path__ + "static/media/cloud-rain.2ed5e84c.png";